import { apiUrl } from "../../config/api";
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import './Article.css';
import './Article.mobile.css';

const Article = () => {
	const { slug } = useParams();
	const [article, setArticle] = useState(null);
	const [error, setError] = useState(null);

	useEffect(() => {
		fetch(apiUrl(`/api/blog/articles/${slug}/`))
			.then((res) => {
				if (!res.ok) throw new Error("Article introuvable");
				return res.json();
			})
			.then((data) => setArticle(data))
			.catch((err) => setError(err.message));
	}, [slug]);

	if (error) {
		return (
			<div className="article-error">
				<span className="error-label">404</span>
				<p>{error}</p>
				<Link to="/blog" className="article-back">← RETOUR AU BLOG</Link>
			</div>
		);
	}

	if (!article) {
		return (
			<div className="article-loading">
				<span>CHARGEMENT</span>
			</div>
		);
	}

	return (
		<div className="article">
			<div className="article-header">
				<Link to="/blog" className="article-back">← BLOG</Link>
				<div className="article-meta">
					{article.created_at
						? new Date(article.created_at).toLocaleDateString("fr-FR", {
							day: "2-digit",
							month: "long",
							year: "numeric",
						})
						: ""}
				</div>
			</div>

			<h1 className="article-title">{article.title}</h1>

			<div className="article-divider">
				<span className="divider-text">✦</span>
			</div>

			<div
				className="article-body"
				dangerouslySetInnerHTML={{ __html: article.content }}
			/> 

			<div className="article-footer">
				<Link to="/blog" className="article-back-footer">← RETOUR AU BLOG</Link>
			</div>
		</div>
	);
};

export default Article;